$.fn.textNodeText = function() {
  let result = ""
  $(this).contents().each(function() {
    if (this.nodeType === 3 && this.data) {
      result += jQuery.trim( $(this).text() )
    }
  })
  return result
}